/**
 * Legend subcomponents themeable props.
 */
import { stringLiteralArray } from "../utils"

export default {
  appearances: stringLiteralArray(["default", "ghosted"])
}
